// extracted by mini-css-extract-plugin
module.exports = {"btnTransparentIcon":"btn_icon_style-module__btnTransparentIcon___zFm5r","maroonIcon":"btn_icon_style-module__maroonIcon___3p5Fv"};